<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>

    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList" />
      <div class="dp-dept-hint">
        <span class="dp-dept-hint__label">所属机构</span>
        <span class="dp-dept-hint__value">{{ currentDepartmentName || "全部" }}</span>
      </div>
      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="listLoading" style="width: 100%" height="100%">
        <el-table-column prop="Name" label="姓名" min-width="100" />
        <el-table-column prop="DepartmentName" label="所属部门" min-width="120" />
        <el-table-column label="所属校区" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="getCampusName(scope.row.CampusId) && getCampusName(scope.row.CampusId) !== '-'" size="mini" type="primary" effect="plain">{{ getCampusName(scope.row.CampusId) }}</el-tag>
            <el-tag v-else size="mini" type="info" effect="plain">未关联校区</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="TeacherName" label="关联教师" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.TeacherName" size="mini" type="primary" effect="plain">{{ scope.row.TeacherName }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.Enabled ? 'success' : 'danger'">
              {{ scope.row.Enabled ? "启用" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip />
        <el-table-column prop="CreateTime" label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.CreateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total,prev,pager,next"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          style="float: right"
        />
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="450px" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->
          <el-form-item label="所属校区" prop="CampusId">
            <el-select
              v-model="editForm.CampusId"
              placeholder="请选择校区"
              style="width: 100%"
              clearable
              @change="handleCampusChange"
            >
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="审核人" prop="TeacherId">
            <div class="ps-pick-summary">
              <span v-if="editForm.TeacherId">
                已选 <strong>{{ selectedPersonLabel || ('教职工#' + editForm.TeacherId) }}</strong>
              </span>
              <span v-else class="muted-text">请选择一名教职工</span>
              <el-button type="primary" size="mini" plain @click="openPersonPicker">选择教职工</el-button>
              <el-button v-if="editForm.TeacherId" type="text" size="mini" @click="clearTeacherPick">清空</el-button>
            </div>
            <div class="form-tip">从通讯录选择，仅绑定一人</div>
          </el-form-item>
          <el-form-item label="姓名" prop="Name">
            <el-input v-model="editForm.Name" maxlength="50" placeholder="审核人姓名（自动带出）" />
          </el-form-item>
          <el-form-item label="启用状态">
            <el-switch v-model="editForm.Enabled" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.Remark" :rows="2" maxlength="500" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <person-scope-picker-dialog
        :visible.sync="personPickerVisible"
        directory-scope="internal"
        :show-scope-tabs="false"
        :scope-department-id="editForm.DepartmentId || DepartmentId"
        :value="editForm.TeacherId"
        :label="selectedPersonLabel"
        @confirm="onPersonPicked"
      />
    </section>
  </section>
</template>

<script>
import {
  getScreenContentApproverList,
  saveScreenContentApprover,
  deleteScreenContentApprover
} from "@/api/dismissal";
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";
import PersonScopePickerDialog from "../../components/PersonScopePickerDialog";
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps';

export default {
  name: "ScreenContentApprover",
  components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      DepartmentId: 0,
      currentDepartmentName: "",
      searchList: [
        { label: "姓名", key: "name" },
        { label: "选择校区", key: "campusId", type: "select", clearable: true, options: [] }
      ],
      filters: { name: "", campusId: null },
      buttonList: [],
      dialogTitle: "",
      editFormVisible: false,
      editLoading: false,
      campusOptions: [],
      personPickerVisible: false,
      selectedPersonLabel: "",
      editFormRules: {
        CampusId: [{ required: true, message: "请选择所属校区", trigger: "change" }],
        TeacherId: [{ required: true, message: "请选择审核教师", trigger: "change" }],
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
      },
      editForm: {
        Id: 0,
        DepartmentId: 0,
        CampusId: null,
        TeacherId: null,
        Name: "",
        Enabled: true,
        Remark: ""
      }
    };
  },
  methods: {
    treeNodeClick(data) {
      if (data.value == '0') {
        this.$message.warning('请选择具体的学校或校区进行操作');
        this.DepartmentId = 0;
        this.currentDepartmentName = '';
        this.clearCampusFilter();
        this.list = [];
        return;
      }
      const id = treeNodeDeptId(data);
      if (!id) return;
      this.DepartmentId = id;
      this.currentDepartmentName = data.label || "";
      this.clearCampusFilter();
      if (this.DepartmentId) {
        this.loadCampusOptions(this.DepartmentId);
        this.handleQuery();
      } else {
        this.list = [];
      }
    },
    /** 清空工具栏校区筛选（切换学校时防止残留旧校区）。最后更新：2026-08-30 */
    clearCampusFilter() {
      this.filters = { ...(this.filters || {}), campusId: null };
      this.campusOptions = [];
      this.syncCampusSearchOptions();
      if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
        this.$set(this.$refs.toolbar.searchObj, "campusId", null);
      }
    },
    /** 与 DutyStaff 一致：把校区列表同步到工具栏「选择校区」下拉 */
    syncCampusSearchOptions() {
      const campusSearch = this.searchList.find(e => e.key === "campusId");
      if (campusSearch) {
        campusSearch.options = (this.campusOptions || []).map(e => ({
          label: e.Name,
          value: e.Id
        }));
      }
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    getList() {
      if (!this.DepartmentId) return;
      this.listLoading = true;
      const para = {
        page: this.page,
        intPageSize: this.pageSize,
        departmentId: this.DepartmentId,
        ...this.filters
      };
      if (para.campusId == null || para.campusId === "" || para.campusId === 0) {
        delete para.campusId;
      }
      getScreenContentApproverList(para)
        .then(res => {
          if (res.data.success && res.data.response) {
            const resp = res.data.response;
            this.list = resp.data || [];
            this.total = resp.dataCount || 0;
          } else {
            this.list = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.list = [];
          this.total = 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      } else {
        this.filters = { name: item.search, campusId: null };
      }
      if (this[item.Func]) this[item.Func].apply(this, item);
    },
    loadCampusOptions(deptId) {
      const id = deptId || this.editForm.DepartmentId || this.DepartmentId;
      if (id) {
        getCampusList({ page: 1, intPageSize: 999, departmentId: id }).then(res => {
          if (res.data.success && res.data.response) {
            this.campusOptions = res.data.response.data || [];
          } else {
            this.campusOptions = [];
          }
          this.syncCampusSearchOptions();
        });
      } else {
        this.campusOptions = [];
        this.syncCampusSearchOptions();
      }
    },
    /** 换校区时清空已选审核人（权限范围变更）。创建于 2026-09-23 */
    handleCampusChange() {
      this.clearTeacherPick();
      this.editForm.Name = "";
    },
    /** 打开内部通讯录单选教职工。创建于 2026-09-23 */
    openPersonPicker() {
      const schoolId = this.editForm.DepartmentId || this.DepartmentId;
      if (!schoolId) {
        this.$message.warning("请先在左侧选择学校！");
        return;
      }
      this.personPickerVisible = true;
    },
    clearTeacherPick() {
      this.editForm.TeacherId = null;
      this.selectedPersonLabel = "";
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.validateField("TeacherId");
      });
    },
    onPersonPicked(person) {
      if (!person) return;
      this.editForm.TeacherId = person.id;
      this.selectedPersonLabel = person.name || "";
      if (person.name) this.editForm.Name = person.name;
      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.validateField("TeacherId");
          this.$refs.editForm.validateField("Name");
        }
      });
    },
    handleAdd() {
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.dialogTitle = "新增审核人";
      this.selectedPersonLabel = "";
      const presetCampus = toDeptId(this.filters.campusId) || null;
      this.editForm = {
        Id: 0,
        DepartmentId: this.DepartmentId,
        CampusId: presetCampus,
        TeacherId: null,
        Name: "",
        Enabled: true,
        Remark: ""
      };
      this.loadCampusOptions(this.DepartmentId);
      this.editFormVisible = true;
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
    },
    handleEdit(row) {
      this.dialogTitle = "编辑审核人";
      this.editForm = {
        Id: row.Id,
        DepartmentId: row.DepartmentId || this.DepartmentId,
        CampusId: toDeptId(row.CampusId) || row.CampusId,
        TeacherId: row.TeacherId,
        Name: row.Name,
        Enabled: row.Enabled,
        Remark: row.Remark || ""
      };
      this.selectedPersonLabel = row.TeacherName || row.Name || "";
      this.loadCampusOptions(this.editForm.DepartmentId);
      this.editFormVisible = true;
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
    },
    handleDel(row) {
      this.$confirm("确认删除该审核人吗？", "提示", { type: "warning" }).then(() => {
        deleteScreenContentApprover({ id: row.Id }).then(res => {
          if (res.data.success) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    editSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editLoading = true;
          const para = {
            Id: this.editForm.Id,
            DepartmentId: this.editForm.DepartmentId || this.DepartmentId,
            CampusId: toDeptId(this.editForm.CampusId) || '',
            TeacherId: this.editForm.TeacherId,
            Name: this.editForm.Name,
            Enabled: this.editForm.Enabled,
            Remark: this.editForm.Remark
          };
          saveScreenContentApprover(para)
            .then(res => {
              this.editLoading = false;
              if (res.data.success) {
                this.$message.success("保存成功");
                this.editFormVisible = false;
                this.getList();
              } else {
                this.$message.error(res.data.msg || "保存失败");
              }
            })
            .catch(() => {
              this.editLoading = false;
            });
        }
      });
    },
    getCampusName(campusId) {
      if (campusId == null || campusId === "") return "-";
      const c = this.campusOptions.find(x => x.Id === campusId);
      return c ? c.Name : campusId;
    },
    formatTime(time) {
      if (!time || time === "0001-01-01T00:00:00") return "";
      const d = new Date(time);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    }
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some(b => b.Func === "handleQuery")) {
      this.buttonList.unshift({ name: "查询", Func: "handleQuery", id: 999 });
    }
    if (!this.buttonList.some(b => b.Func === "handleAdd")) {
      this.buttonList.push({ name: "新增", Func: "handleAdd", id: 998 });
    }
  }
};
</script>

<style scoped>
.pagination-container {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
.muted-text {
  color: #94a3b8;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 6px;
}
</style>
